// TDIC: TimeUtil.js added
import moment from 'moment';

function getAvailableTime(startHour = 8, endHour = 16, minutesInterval = 60) {
    const times = [];
    const period = ['AM', 'PM'];
    const dt = new Date(1970, 0, 1, startHour, 0, 0);
    while (dt.getDate() === 1 && dt.getHours() <= endHour) {
        const hours = dt.getHours();
        const minutes = dt.getMinutes();
        times.push(`${(`0${hours === 12 ? 12 : hours % 12}`).slice(-2)}:${(`0${minutes}`)
            .slice(-2)} ${period[Math.floor(hours / 12)]}`);
        dt.setMinutes(dt.getMinutes() + minutesInterval);
    }
    return times;
}

function timeGreaterThan(start, end) {
    return (moment(start, 'hh:mm a') > moment(end, 'hh:mm a'));
}

function currentTime() {
    return moment().format('hh:mm a');
}

function timeLessThan(start, end) {
    return (moment(start, 'hh:mm a') < moment(end, 'hh:mm a'));
}

export default {
    getAvailableTime, timeGreaterThan, timeLessThan, currentTime
};
